import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { downloadFileFromResponse } from '@cbridge-utils/file';
import { catchApiError, IClientApiDependencySegment } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { ScheduleAction } from '../schedule.action';

type IDependencies = IClientApiDependencySegment;

export const exportSchedulesEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(ScheduleAction.exportFile.started),
  mergeMap((params) => {
    return dependencies.api.exportSchedulesFile(params).pipe(
      mergeMap((response) => {
        downloadFileFromResponse(response);
        return [];
      }),
      catchApiError((error) => {
        return [ScheduleAction.exportFile.failed({ params, error }), createApiErrorNotification(error)];
      }),
    );
  }),
);
